import { gql } from '@apollo/client';

import { Return } from '@rebound/shared-models/return/return.model';

import { ReturnFragment } from '@modules/dashboard/dashboard.queries';

export const FindReturnByTrackingQuery = gql`
  query findReturnByTracking($trackingOrNumber: String!) {
    findReturnByTracking(trackingOrNumber: $trackingOrNumber) {
      ...ReturnFields
    }
  }

  ${ReturnFragment}
`;

export type FindReturnByTrackingQueryResult = {
  findReturnByTracking: Return[];
};
